import { Controller } from "@hotwired/stimulus";

// 支払期限が無効な場合の再設定入力欄と、当選確定ボタンの活性/非活性を連動させる
// Connects to data-controller="deadline-confirm"
export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.toggle();
  }

  toggle() {
    this.buttonTarget.setAttribute("aria-disabled", this.inputTarget.value === "" ? "true" : "false");
  }
}
